<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Sélectionner un véhicule</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label">Supplier
              <select name="options"
                      class="form-control border-none"
                      v-model="filters.realm">
                <option :value="null" selected>Supplier</option>
                <option v-for="(item, index) in suppliers"
                        :key="index"
                        :value="item">{{ item | capitalize }}</option>
              </select>
            </label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label">ID
              <input type="text"
                     placeholder="ID"
                     class="form-control"
                     v-model="filters.id">
            </label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label"
                   style="position: relative;">Marque
              <input type="text"
                     placeholder="Marque"
                     class="form-control"
                     @focus="showAutoComplete = true"
                     @blur="hideAutoComplete"
                     v-model="filters.make">
              <ul v-if="showAutoComplete && filteredMakesList.length && filters.make.length"
                  class="typeahead dropdown-menu"
                  style="display: block;">
                <li v-for="(make, index) in filteredMakesList"
                    :key="index">
                  <a class="dropdown-item"
                     role="option"
                     href="#"
                     @click.prevent.stop="assignMake(make)">{{ make }}</a>
                </li>
              </ul>
            </label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label">Modèle
              <input type="text"
                     placeholder="Modèle"
                     class="form-control"
                     v-model="filters.model">
            </label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label">Finition
              <input type="text"
                     placeholder="Finition"
                     class="form-control"
                     v-model="filters.version">
            </label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label">Prix ({{ filters.rangePrice.min }} - {{ filters.rangePrice.max }})</label>
              <range-slider
                      :ballWidth="25" :barHeight="10"
                      :min="1000" :max="100000"  :step="1000" class="rangeSlider"
                      :start="filters.rangePrice.min" :end="filters.rangePrice.max"
                      @slideEnd="slideEnd">
              </range-slider>
          </div>
        </div>
      </div>

      <spinner-three-bounce :displayNone="!$apollo.queries.ad.loading"/>

      <div v-if="showAdList"
           class="row bloc-information"
           style="overflow: auto; height: 400px;">
        <div v-for="(item, index) in ad"
             :key="index"
             class="col-lg-12 car"
             @click="selectAd(item)">
          <div class="car-reserved" v-if="parseInt(item.status) === 5">{{ item.statusAsString }}</div>
          <div class="ibox float-e-margins">
            <div class="ibox-content col-lg-4" style="min-height: 155px;">
              <a :href="getUrl(item)"
                 target="_blank"
                 @click.stop>
                <img :src="vehicle(item).photo" class="img-vehicle">
              </a>
            </div>
            <div class="col-lg-8 no-paddings">
              <div v-if="item.id === selectedAd.id"
                   class="btn btn-primary btn-circle"
                   style="position: absolute; right: 10px; top: 10px;">&#10004;</div>
              <div class="ibox-title">
                <h5 style="position:absolute; width:96%;">
                  <strong>{{ `${vehicle(item).make} ${vehicle(item).model} ${vehicle(item).version}` }}<br>
                    <span class="orange">{{ item.buyerPrice}} €</span></strong></h5>
              </div>
              <div class="ibox-content" style="border-top:none;">
                <i class="fa fa-road"></i> {{ vehicle(item).kilometers.toLocaleString() }} km<br>
                <i class="fa fa-money"></i> {{ vehicle(item).fuel }}<br>
                <i class="fa fa-flag-checkered"></i> {{ vehicle(item).licensePlate }},
                {{ vehicle(item).year }},
                {{ vehicle(item).gearType }},
                {{ vehicle(item).city }} ({{ vehicle(item).department }})
                <br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button"
              class="btn"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-primary"
              @click="onSubmit"
              :disabled="!selectedAd.id">Selectionner ce véhicule</button>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
  import RangeSlider from 'range-slider-vue';



  export default {
    components: {
      SpinnerThreeBounce,
      RangeSlider
    },

    data: () => ({
      ad: [],
      selectedAd: {},
      filters: {
        realm: '',
        id: '',
        make: '',
        model: '',
        version: '',
        rangePrice: {
          min: 1000,
          max: 100000
        },
        limit: 10,
      },
      skipQuery: true,
      showAutoComplete: false,
      suppliers: [
        'renault',
        'carizy'
      ],
      makes: [
        "ABARTH",
        "ALFA ROMEO",
        "ASTON MARTIN",
        "AUDI",
        "BENTLEY",
        "BMW",
        "CITROEN",
        "DACIA",
        "DS",
        "FERRARI",
        "FIAT",
        "FORD",
        "HONDA",
        "HYUNDAI",
        "INFINITI",
        "JAGUAR",
        "JEEP",
        "KIA",
        "LADA",
        "LAMBORGHINI",
        "LAND ROVER",
        "LEXUS",
        "LOTUS",
        "MASERATI",
        "MAZDA",
        "MCLAREN",
        "MERCEDES-BENZ",
        "MINI",
        "MITSUBISHI",
        "NISSAN",
        "OPEL",
        "PEUGEOT",
        "PORSCHE",
        "RENAULT",
        "ROLLS ROYCE",
        "SEAT",
        "SKODA",
        "SMART",
        "SSANGYONG",
        "SUBARU",
        "SUZUKI",
        "TESLA",
        "TOYOTA",
        "VOLKSWAGEN",
        "VOLVO"]
    }),

    computed: {
      showAdList () {
        return (this.ad && this.ad.length && !this.$apollo.queries.ad.loading)
      },

      filteredMakesList () {
        return this.makes.filter(m => m.toLowerCase().includes(this.filters.make.toLowerCase())
            && m.toLowerCase() !== this.filters.make.toLowerCase()).slice(0, 10)
      },

      filtersVehicle () {
        return JSON.stringify(this.filters)
      },

      vehicleListQuery () {
        let queries = []
        for (let key in this.filters) {
          if (this.filters[key]) {
            if (['make', 'model', 'version', 'realm'].includes(key)) {
                queries.push(key + ': "' + this.filters[key] + '"')
            } else if (['rangePrice'].includes(key)) {
              if (this.filters.rangePrice.min && this.filters.rangePrice.max) {
                queries.push('rangePrice: { min:' + this.filters.rangePrice.min + ', max: ' + this.filters.rangePrice.max + '}')
              }
            } else {
              queries.push(key + ': ' + this.filters[key])
            }
          }
        }
        return gql`
        query {
          ad (${queries.join(', ')}){
          id
          realm
          supplier
          transaction
          status
          statusAsString
          buyerPrice
          saleCommission
          vehicle {
           id
           make
           model
           version
           color
           fuel
           licensePlate
           city
           department
           kilometers
           gearType
           releaseDate
           year
           body
           doorsNumber
           photo
           url
           technicalControlValidity
           appraisalExpert {
             id
             name
           }
           appraisalDate
         }
         seller {
          id
          firstname
          lastname
          phone
          email
          address {
            address
            city
            zipCode
          }
        }
       }
      }
        `
      }
    },

    watch: {
      filtersVehicle () {
        this.skipQuery = false
        this.$apollo.queries.ad.refetch()
      },
      ad() {
        if(!this.ad || this.ad.length === 0){
          this.showBanner('danger', "Désolé le véhicule que vous recherchez n'existe pas.")
        }
      },
    },

    methods: {
      getUrl (item) {
        let domain = null

        if (item.realm === "renault") {
          domain = process.env.VUE_APP_REP_DOMAIN
        } else {
          domain = process.env.VUE_APP_FRONTOFFICE_DOMAIN
        }

        return domain + this.vehicle(item).url
      },

      slideEnd(e) {
        this.filters.rangePrice.min = e.start
        this.filters.rangePrice.max = e.end
      },

      assignMake (make) {
        this.filters.make = make
        this.showAutoComplete = false
      },

      hideAutoComplete () {
        setTimeout(() => {
          this.showAutoComplete = false
        }, 100)
      },

      vehicle (item) {
        return item.vehicle[0]
      },

      async selectAd (ad) {
        if (this.selectedAd === ad || parseInt(ad.status) === 5) return false;

        if (ad.supplier === 'RRG') {
          const result = await this.$apollo.query({
            query: gql`
              query {
                ad(id: ${ ad.id }) {
                  status
                  statusAsString
                }
              }
            `,
            fetchPolicy: 'no-cache'
          });
          ad.status = result.data.ad[0].status;
          ad.statusAsString = result.data.ad[0].statusAsString;
          this.selectedAd = (parseInt(ad.status) === 5) ? {} : ad;
        } else {
          this.selectedAd = ad;
        }
      },

      onSubmit () {
        this.$bus.$emit('select-ad-success', this.selectedAd)
        this.closeModal()
      }
    },

    apollo: {
      ad: {
        query () {
          return this.vehicleListQuery
        },
        skip () {
          return this.skipQuery
        }
      },
    }
  }
</script>

<style lang="scss">

  .round-bar .round-bar-track .track-round {
    background: #1b997f !important;
  }

</style>